import apiClient from '../../../api/core/apiClient';
import { endpoints } from '../../../api/core/endpoints';
import type { QuickReply, CreateQuickReplyDto, UpdateQuickReplyDto } from '../types/quick-replies';

const BASE = endpoints.collections.catalogs;

export const getQuickReplies = (): Promise<QuickReply[]> =>
  apiClient.get<QuickReply[]>(`${BASE}/types`);

export const createQuickReply = (data: CreateQuickReplyDto): Promise<QuickReply> =>
  apiClient.post<QuickReply>(BASE, data);

export const updateQuickReply = (id: string, data: UpdateQuickReplyDto): Promise<QuickReply> =>
  apiClient.put<QuickReply>(`${BASE}/${id}`, data);

export const deleteQuickReply = (id: string): Promise<void> =>
  apiClient.delete<void>(`${BASE}/${id}`);
